import { Button, Tooltip } from '@mui/material'
import { GridApiPremium } from '@mui/x-data-grid-premium/models/gridApiPremium'
import Image from 'next/image'
import { RefObject, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { track } from '@omnea-app/fe-analytics/useAnalytics'
import { AiFilterDialog } from './components/AIFilterDialog'

interface AiFilterCreatorProps {
  tableName: string
  apiRef: RefObject<GridApiPremium>
  disabled?: boolean
}

export const AiFilterCreator: React.FC<AiFilterCreatorProps> = ({ apiRef, tableName, disabled }) => {
  const { t } = useTranslation('common')
  const [isAiFilterDialogOpen, setAIFilterOpen] = useState(false)
  function handleOpenDialog() {
    setAIFilterOpen(true)
    track('AIFilterClicked', {
      tableName: tableName.toLowerCase(),
    })
  }

  return (
    <>
      <Tooltip title={t('table.table-toolbar.ai-filter-button-tooltip')} describeChild>
        <Button
          color="secondary"
          size="small"
          disabled={disabled}
          onClick={handleOpenDialog}
          startIcon={<Image alt="" src="/app/assets/ai-filter-logo.svg" width={18} height={18} />}
        >
          {t('table.table-toolbar.ai-filter-button-label')}
        </Button>
      </Tooltip>
      <AiFilterDialog open={isAiFilterDialogOpen} onClose={() => setAIFilterOpen(false)} apiRef={apiRef} tableName={tableName} />
    </>
  )
}
